import { Form, Row } from "antd";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";
import React, { useImperativeHandle,forwardRef } from "react";
import Calendar from "../../../../../../../CommonComponents/Calendar/Calendar";
import CurrencyInput from "../../../../../../../CommonComponents/CurrencyInput/CurrencyInput";
import regexMap from "../../../../../../../utils/regexMap";
import { ErrorMsgWrap } from "../../../style";
import { BoxDetailWrapper, InputWrappercal } from "../style";
import Heading from "./Heading";
import InfoBlock from "./InfoBlock";

export const customValidator = (rules,value,callback,availableBalance,realAvailableBalance)=>{
    try 
    {
         if(parseFloat(value)>availableBalance || parseFloat(value)>realAvailableBalance)
        {
            throw new Error("The grant amount entered exceeds the account balance. Please enter a value less than the account balance.")
        }
        else if(value<500)
        {
            throw new Error("Enter a minimum of $500.")
        }
        callback()
    }
    catch (error)
    {
        callback(error)

    }
    
}

export const disabledDate = (current) => current && current < moment().subtract(1, "days");


export const EditRecommendAllocation = forwardRef(({form,availableBalance,selectedDate,grantAmount,realAvailableBalance},ref) => {
    const {getFieldDecorator, getFieldsError, validateFields } = form;

    const {amount:amountError,startDate:dateError} = getFieldsError();
    useImperativeHandle(ref, () => ({
        form,
      }));

   return ( <>
        <Heading
            id="btnRecomamountallocation"
            title="Recommended amount & allocation "
        />

        <Row type="flex">
            <BoxDetailWrapper md={6} xs={24}>
                <InfoBlock
                    border
                    title="Payment"
                    value="One Time Payment"
                />
            </BoxDetailWrapper>

            <BoxDetailWrapper md={6} xs={24} className={"edit-spawn-pb0-mob"}>
                <FormItem>
                <InfoBlock
                    border
                    title="Scheduled Issue Date"
                    value={
                        <InputWrappercal>

                        {
                            getFieldDecorator("startDate",{
                                initialValue:moment(selectedDate, "MM/DD/YYYY"),
                                rules:[{required:true,message:"Please enter Scheduled Issue Date"}]
                            })(

                            <Calendar
                                ariaLabel="startDate"
                                allowClear={false}
                                placeHolder="Select date"
                                readOnly={false}
                                format="MM/DD/YYYY"
                                disabledDate={disabledDate}
                                className={"recurring-grant-datepicker"}
                            />
                            )
                        }
                        </InputWrappercal>

                    }
                />
                 {dateError&& <ErrorMsgWrap>
                            {dateError[0]}
                        </ErrorMsgWrap>}
                </FormItem>
            </BoxDetailWrapper>

            <BoxDetailWrapper md={6} xs={24} className="edit-spawn-pt0-mob">
                <FormItem>
                <InfoBlock
                    border
                    title="Total Payment"
                    value={
                        <>
                        {
                        getFieldDecorator("amount",{
                            initialValue:grantAmount,
                            rules:[{required:true,message:"Please enter grant amount."},{validator:(rules,value,cb)=>{
                                customValidator(rules,value,cb,availableBalance,realAvailableBalance)
                            },
                      }],
                      normalize:(value,oldvalue,allValue)=>{
                        return regexMap.twoDecimal.test(value)?value:oldvalue;   
                    }
                        })(
                        <CurrencyInput
                            id="receditamount"
                            focus={false}
                            name="amount"
                            label="total-amount"
                            aria-label="total amount"
                            placeholder="Enter grant amount"
                            maxLength={150}
                            disabled={false}
                            className={"spawnEditAmount"}
                        />
                        )
                    }
                      
                        </>
                    }
                />
                 {amountError&& <ErrorMsgWrap>
                            {amountError[0]}
                        </ErrorMsgWrap>}

</FormItem>
            </BoxDetailWrapper>

        </Row>

    </>

)
                })
const WrappedFormRecommendAllocation = Form.create(
    {
        name:"editRecommendAllocation",
        onFieldsChange:(props,changedFields,values)=>{
            props.handleFormChange(changedFields,values);
        }
    }
)(EditRecommendAllocation)

export default WrappedFormRecommendAllocation